import React, { useState, useEffect } from "react";
import { createModel } from "hox";
import useStorageState from "@/hooks/useStorageState";
import { globalPrompt } from "@/components/message";
import { dictService, ISCMDictDetail, ISCMDictSearch } from "./dictService";
import { forFind } from "@/utils/utils";
import { DictCodeEnmu } from "../../../types/VrmSaDictEnums"
import { useGlobalModel } from "@/model/globalModel";

import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
type dictObj = {
    [key: string]: any
}
type ISelectOptions = {
    label: string,
    value: string
}
export type ITreeSelectData = {
    title: string,
    value: string,
    children: ITreeSelectData[]
}
function listChangeTree(list: ISCMDictDetail[]) {
    let menuObj: dictObj = {}
    list.forEach(item => {
        item.children = []
        menuObj[item.code] = item
    })
    return list.filter(item => {
        if (item.pcode !== null && item.pcode !== "") {
            menuObj[item.pcode]?.children.push(item)
            return false
        }
        return true
    })
}

export const useDictModel = createModel(function () {
    const { language, setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const [treeSource, setTreeSource, clearTreeSource] = useStorageState<ISCMDictDetail[]>("dictTree", []);  //字典数据源
    const [selectedNodes, setSelectedNodes] = useState<ISCMDictDetail[]>([]);   //树选中的行信息
    const [mode, setMode] = useState<"add" | "edit" | "nextInsert" | "">("");
    const [formVal, setFormVal] = useState<ISCMDictDetail>(selectedNodes[0]);  //表单缓存

    //实时缓存
    const onChangeFormVal = (changedValues: { [key: string]: any }) => {
        setFormVal({ ...formVal, ...changedValues });
    }

    const initDictFormFields = {
        pcode: "",
        code: "",
        name: "",
        note: "",
        ver: 0,
        sourceAuthKey: "",
        children: [],
        enable: 1,
        status: 1,
        branch: "",
        value: "",
        key: ""
    }
    useEffect(() => {
        if (mode === "add") {
            console.log(selectedNodes[0])
            setFormVal({ ...selectedNodes[0], ...initDictFormFields, pcode: selectedNodes[0].pcode })
        } else if (mode === "nextInsert") {
            setFormVal({ ...selectedNodes[0], ...initDictFormFields, pcode: selectedNodes[0].code })
        }
    }, [mode])

    const loadData = async () => {
        let data: ISCMDictSearch = {
            sourceApp: "main",
            // branch: "vrm-sa",
            page: {
                pageSize: 10000000,
                pageNum: 1,
            },
        }
        let { retData } = await dictService.page(data);
        let { records } = retData;
        setTreeSource(listChangeTree(records));
    }

    //表单提交
    const onSubmit = async () => {
        // return console.log(formVal)
        let { code, pcode, note, name, enable, nameEn, status } = formVal;
        let data = {
            "sourceApp": "vrm",
            "branch": "vrm-sa",
            code, pcode, note, name, nameEn,
            enable: enable ? 1 : 0
        }
        if (!data.code) {
            // globalPrompt("message", { text: "编码为必填项", type: "warning" });
            globalPrompt("message", { text: Locale["The code is required."], type: "warning" });
            return;
        }
        if (mode === "add" || mode === "nextInsert") {
            let { retData } = await dictService.insert(data);
            // retData && globalPrompt("message", { type: "success", text: "字典增加成功" });
            globalPrompt("message", { text: Locale["New data dic has been successfully added."], type: "warning" });
            loadData();
            setSelectedNodes([]);
        } else if (mode === "edit") {
            let { retData } = await dictService.update(data);
            // retData && globalPrompt("message", { type: "success", text: "字典编辑成功" });
            globalPrompt("message", { text: Locale["New data dic has been successfully edited."], type: "warning" });
            loadData();
            setSelectedNodes([]);
        }
    }
    const onLocalSubmit = async () => {
        // return console.log(formVal)
        let { code, pcode, note, name, enable, nameEn, status } = formVal;
        let data = {
            "sourceApp": "vrm",
            "branch": "main",
            code, pcode, note, name, nameEn,
            enable: enable ? 1 : 0
        }
        if (!data.code) {
            // globalPrompt("message", { text: "编码为必填项", type: "warning" });
            globalPrompt("message", { text: Locale["The code is required."], type: "warning" });
            return;
        }
        if (mode === "add" || mode === "nextInsert") {
            let { retData } = await dictService.insertLocal(data);
            // retData && globalPrompt("message", { type: "success", text: "字典增加成功" });
            globalPrompt("message", { text: Locale["New data dic has been successfully added."], type: "warning" });
            loadData();
            setSelectedNodes([]);
        } else if (mode === "edit") {
            let { retData } = await dictService.updateLocal(data);
            // retData && globalPrompt("message", { type: "success", text: "字典编辑成功" });
            globalPrompt("message", { text: Locale["New data dic has been successfully edited."], type: "warning" });
            loadData();
            setSelectedNodes([]);
        }
    }
    //删除一条数据
    const removeOneDict = async (code: string) => {
        let data = {
            sourceApp: "scm",
            branch: "main",
            code
        }
        let { retData } = await dictService.remove(data);
        // retData && globalPrompt("message", { type: "success", text: "字典删除成功" });
        globalPrompt("message", { text: Locale["New data dic has been successfully deleted."], type: "warning" });

        loadData();
        setSelectedNodes([]);
    }

    //根据code返回 select框的options 格式；
    const getSelectedDictOne = (code: string): ISelectOptions[] => {
        let findTree: ISCMDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? findTree.children.map(item => ({ label: language == "zh-CN" ? item.name : item.nameEn as string, value: item.code })) : []
    }

    //根据code 返回对应的node节点名称
    const getTreeNodeName = (code: string): string => {
        let obj: dictObj = {};
        let findTree: ISCMDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? findTree["name"] : "";
    }

    //根据code 返回对应树节点
    const getTreeNodeOne = (code: string): ISCMDictDetail[] => {
        let findTree: ISCMDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? [findTree] : [];
    }

    const mapTree = (org: ISCMDictDetail): ITreeSelectData => {
        const haveChildren = Array.isArray(org.children) && org.children.length > 0;
        return {
            title: language == "zh-CN" ? org.name : org.nameEn as string,
            value: org.code,
            //判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
            children: haveChildren ? org.children.map(i => mapTree(i)) : []
        };
    }
    //根据code 返回treeSelect 数据格式
    const getTreeSelectOne = (code: DictCodeEnmu): ITreeSelectData[] => {
        let findTree: ISCMDictDetail | undefined = forFind(treeSource, code, "code");
        return findTree ? mapTree(findTree).children : [];
    }
    return {
        /***field***/
        treeSource,
        selectedNodes,
        mode,
        formVal,
        /***method***/
        setTreeSource,
        setSelectedNodes,
        setMode,
        setFormVal,
        onChangeFormVal,
        loadData,
        onSubmit,
        getTreeNodeName,
        getSelectedDictOne,
        getTreeNodeOne,
        getTreeSelectOne,
        onLocalSubmit
    }
});